"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.supabase = void 0;

const supabase = client => {
  return {
    type: 'supabase',
    client,
    login: async ({
      email,
      password,
      provider
    }) => {
      // magic link
      if (email && !password) {
        return await client.auth.signIn({
          email
        });
      } // email and password


      if (email && password) {
        return await client.auth.signIn({
          email,
          password
        });
      } // oauth, such as github, gitlab, bitbucket, google, azure etc.


      if (provider) return await client.auth.signIn({
        provider
      });
      throw new Error("You must provide either an email or a third-party provider.");
    },
    logout: async () => {
      return await client.auth.signOut();
    },
    signup: async ({
      email,
      password
    }) => {
      return await client.auth.signUp({
        email,
        password
      });
    },
    getToken: async () => {
      const currentSession = client.auth.session();
      return (currentSession === null || currentSession === void 0 ? void 0 : currentSession.access_token) || null;
    },
    getUserMetadata: async () => {
      return await client.auth.user();
    },
    // restore authentication when an OAuth or magiclink callback
    // redirects back to site with access token
    restoreAuthState: async () => {
      return await client.auth.refreshSession();
    }
  };
};

exports.supabase = supabase;